<template>
  <div>
    <Head />

    <div class="breadcrumb_box" aria-label="breadcrumb" v-if="EventItemDetailData">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item"><router-link to="/">首頁</router-link></li>
        <li class="breadcrumb-item" v-if="EventItemDetailData.Event">{{ EventItemDetailData.Event.Name }}</li>
        <li class="breadcrumb-item active" v-if="EventItemDetailData.EventItem" aria-current="page">{{
          EventItemDetailData.EventItem.Name }}</li>
      </ol>
    </div>
    <div class="wrapper member_information member_information_1_main member_information_1_main_2"
      v-if="EventItemDetailData.EventItemDetail">
      <section class="main">
        <div class="container">
          <div class="step_box">
            <div class="" @click="goto('BaseInfo')" style="cursor: pointer;">基本資料</div>
            <div class="step">品項管理</div>
            <div class="" @click="goto('ReqDoc')" style="cursor: pointer;">應備文件</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 0" class="" @click="sendReview()"
              style="cursor: pointer;">送出審核</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 3" class="" @click="sendReview()"
              style="cursor: pointer;">重新送出審核</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 1" class="">審核通過</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 2" class="">審核失敗</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 99" class="">審核中</div>
            <div v-if="EventItemDetailData.Review.ReviewStatus == 999" class="">重審中</div>
          </div>
          <div id="stet_1" class="box show">
            <!-- <h1>資料修改</h1> -->
            <h1>
              業者
              <div class="btn_home">
                <router-link :to="{ name: 'EventItem', params: { EId: EventItemDetailData.Event.EId } }"
                  tag="button">返回列表</router-link>
              </div>
            </h1>
            <div class="bg">
              <div class="form-group full">
                <label for=""><span>[必填]</span>業者名稱</label>
                <input type="text" class="form-control" v-model="EventItemDetailData.EventItemDetail.T3_VendorName"
                  data-field="T3_VendorName" data-required="1" data-required-msg="請填寫業者名稱" aria-describedby=""
                  placeholder="請填寫業者名稱">
              </div>
            </div>
            <!-- <hr> -->
            <h1>報名品項資訊</h1>
            <div class="bg">
              <div class="form-group full">
                <label for=""><span>[必填]</span>品項</label>
                <input type="text" class="form-control" v-model="EventItemDetailData.EventItemDetail.T3_Item"
                  data-field="T3_Item" data-required="1" data-required-msg="請填寫品項" aria-describedby=""
                  placeholder="請填寫品項">
              </div>
              <div class="form-group full">
                <label for=""><span>[必填]</span>品項英文名稱</label>
                <input type="text" class="form-control" v-model="EventItemDetailData.EventItemDetail.T3_ItemEnglishName"
                  data-field="T3_ItemEnglishName" data-required="1" data-required-msg="請填寫品項英文名稱" aria-describedby=""
                  placeholder="請填寫品項英文名稱">
              </div>
              <div class="form-group file_box full">
                <label for=""><span>[必填]</span>報名品項、調理產品外觀或產品標示等照片-1<span style="font-size: 1.3rem;"
                    v-if="EventItemDetailData.EventItemDetail.EIDId != -1 && EventItemDetailData.EventItemDetail.T3_ItemPhotos">
                    (已上傳, 可更新)</span></label>
                <div class="file">
                  <input type="file" id="T3_ItemPhotos"
                    accept=".bmp,.jpg,.jpeg,.gif,.png"
                    @change="checkFiles">
                  <input type="hidden" id="T3_ItemPhotos_name" data-namgtag="1" />
                  <input type="hidden" v-model="EventItemDetailData.EventItemDetail.T3_ItemPhotos"
                    data-field="T3_ItemPhotos" id="T3_ItemPhotos_data" data-required="1"
                    data-required-msg="請上傳報名品項、調理產品外觀或產品標示等照片-1" />
                  <button>上傳</button>
                </div>
                <p>
                  可上傳的文件格式包括：JPG或GIF或PNG檔<br>建議每個檔案大小不超過100MB，且圖片檔案建議具備300dpi解析度及至少1000px的寬度。
                </p>
              </div>
              <div class="form-group file_box full">
                <label for="">報名品項、調理產品外觀或產品標示等照片-2<span style="font-size: 1.3rem;"
                    v-if="EventItemDetailData.EventItemDetail.EIDId != -1 && EventItemDetailData.EventItemDetail.T3_ItemPhotos2">
                    (已上傳, 可更新)</span></label>
                <div class="file">
                  <input type="file" id="T3_ItemPhotos2"
                    accept=".bmp,.jpg,.jpeg,.gif,.png"
                    @change="checkFiles">
                  <input type="hidden" id="T3_ItemPhotos2_name" data-namgtag="1" />
                  <input type="hidden" v-model="EventItemDetailData.EventItemDetail.T3_ItemPhotos2"
                    data-field="T3_ItemPhotos2" id="T3_ItemPhotos2_data" />
                  <button>上傳</button>
                </div>
                <p>
                  可上傳的文件格式包括：JPG或GIF或PNG檔<br>建議每個檔案大小不超過100MB，且圖片檔案建議具備300dpi解析度及至少1000px的寬度。
                </p>
              </div>
              <div class="form-group file_box full">
                <label for="">報名品項、調理產品外觀或產品標示等照片-3<span style="font-size: 1.3rem;"
                    v-if="EventItemDetailData.EventItemDetail.EIDId != -1 && EventItemDetailData.EventItemDetail.T3_ItemPhotos3">
                    (已上傳, 可更新)</span></label>
                <div class="file">
                  <input type="file" id="T3_ItemPhotos3"
                    accept=".bmp,.jpg,.jpeg,.gif,.png"
                    @change="checkFiles">
                  <input type="hidden" id="T3_ItemPhotos3_name" data-namgtag="1" />
                  <input type="hidden" v-model="EventItemDetailData.EventItemDetail.T3_ItemPhotos3"
                    data-field="T3_ItemPhotos3" id="T3_ItemPhotos3_data" />
                  <button>上傳</button>
                </div>
                <p>
                  可上傳的文件格式包括：JPG或GIF或PNG檔<br>建議每個檔案大小不超過100MB，且圖片檔案建議具備300dpi解析度及至少1000px的寬度。
                </p>
              </div>
              <div class="form-group file_box full">
                <label for="">報名品項、調理產品外觀或產品標示等照片-4<span style="font-size: 1.3rem;"
                    v-if="EventItemDetailData.EventItemDetail.EIDId != -1 && EventItemDetailData.EventItemDetail.T3_ItemPhotos4">
                    (已上傳, 可更新)</span></label>
                <div class="file">
                  <input type="file" id="T3_ItemPhotos4"
                    accept=".bmp,.jpg,.jpeg,.gif,.png"
                    @change="checkFiles">
                  <input type="hidden" id="T3_ItemPhotos4_name" data-namgtag="1" />
                  <input type="hidden" v-model="EventItemDetailData.EventItemDetail.T3_ItemPhotos4"
                    data-field="T3_ItemPhotos4" id="T3_ItemPhotos4_data" />
                  <button>上傳</button>
                </div>
                <p>
                  可上傳的文件格式包括：JPG或GIF或PNG檔<br>建議每個檔案大小不超過100MB，且圖片檔案建議具備300dpi解析度及至少1000px的寬度。
                </p>
              </div>
              <div class="form-group file_box full">
                <label for="">報名品項、調理產品外觀或產品標示等照片-5<span style="font-size: 1.3rem;"
                    v-if="EventItemDetailData.EventItemDetail.EIDId != -1 && EventItemDetailData.EventItemDetail.T3_ItemPhotos5">
                    (已上傳, 可更新)</span></label>
                <div class="file">
                  <input type="file" id="T3_ItemPhotos5"
                    accept=".bmp,.jpg,.jpeg,.gif,.png"
                    @change="checkFiles">
                  <input type="hidden" id="T3_ItemPhotos5_name" data-namgtag="1" />
                  <input type="hidden" v-model="EventItemDetailData.EventItemDetail.T3_ItemPhotos5"
                    data-field="T3_ItemPhotos5" id="T3_ItemPhotos5_data" />
                  <button>上傳</button>
                </div>
                <p>
                  可上傳的文件格式包括：JPG或GIF或PNG檔<br>建議每個檔案大小不超過100MB，且圖片檔案建議具備300dpi解析度及至少1000px的寬度。
                </p>
              </div>
              <hr>
              <div class="form-group full">
                <label for=""><span>[必填]</span>是否已商品化（製成調理包）</label>
                <div class="check_group radio radio_1">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="T3_IsCommercialized" id="T3_IsCommercialized1"
                      v-bind:value="1" v-model="EventItemDetailData.EventItemDetail.T3_IsCommercialized"
                      data-field="T3_IsCommercialized">
                    <label class="form-check-label" for="T3_IsCommercialized1">
                      是
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="T3_IsCommercialized" id="T3_IsCommercialized2"
                      v-bind:value="2" v-model="EventItemDetailData.EventItemDetail.T3_IsCommercialized"
                      data-field="T3_IsCommercialized">
                    <label class="form-check-label" for="T3_IsCommercialized2">
                      開發中
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="T3_IsCommercialized" id="T3_IsCommercialized3"
                      v-bind:value="0" v-model="EventItemDetailData.EventItemDetail.T3_IsCommercialized"
                      data-field="T3_IsCommercialized">
                    <label class="form-check-label" for="T3_IsCommercialized3">
                      否
                    </label>
                  </div>
                </div>
              </div>
              <div class="form-group full">
                <label for=""><span>[必填]</span>保存方式</label>
                <div class="check_group radio">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_AmbientTemperature"
                      v-model="EventItemDetailData.EventItemDetail.T3_AmbientTemperature"
                      data-field="T3_AmbientTemperature">
                    <label class="form-check-label" for="T3_AmbientTemperature">常溫</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_Refrigerated"
                      v-model="EventItemDetailData.EventItemDetail.T3_Refrigerated" data-field="T3_Refrigerated">
                    <label class="form-check-label" for="T3_Refrigerated">冷藏</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_Frozen"
                      v-model="EventItemDetailData.EventItemDetail.T3_Frozen" data-field="T3_Frozen">
                    <label class="form-check-label" for="T3_Frozen">冷凍</label>
                  </div>
                </div>
              </div>
              <hr>
              <div class="form-group full">
                <label for="">國內通路</label>
                <input type="text" class="form-control"
                  v-model="EventItemDetailData.EventItemDetail.T3_DomesticDistribution"
                  data-field="T3_DomesticDistribution">
              </div>
              <div class="form-group full">
                <label for="">國外通路</label>
                <input type="text" class="form-control"
                  v-model="EventItemDetailData.EventItemDetail.T3_InternationalDistribution"
                  data-field="T3_InternationalDistribution">
              </div>
              <div class="form-group full">
                <label for="">國內洽談中通路</label>
                <input type="text" class="form-control"
                  v-model="EventItemDetailData.EventItemDetail.T3_NegotiatingDomesticDistribution"
                  data-field="T3_NegotiatingDomesticDistribution">
              </div>
              <div class="form-group full">
                <label for="">國外洽談中通路</label>
                <input type="text" class="form-control"
                  v-model="EventItemDetailData.EventItemDetail.T3_NegotiatingInternationalDistribution"
                  data-field="T3_NegotiatingInternationalDistribution">
              </div>
              <hr>
              <div class="form-group full">
                <label for="">成分組成</label>
                <textarea rows="5" v-model="EventItemDetailData.EventItemDetail.T3_IngredientComposition"
                  data-field="T3_IngredientComposition" aria-describedby=""></textarea>
              </div>
              <div class="form-group full">
                <label for="">菜餚或調理包特色說明</label>
                <textarea rows="5" v-model="EventItemDetailData.EventItemDetail.T3_DishOrCookingPackageDescription"
                  data-field="T3_DishOrCookingPackageDescription" aria-describedby=""></textarea>
              </div>
            </div>
            <h1>調理產品檢驗</h1>
            <div class="bg">
              <div class="form-group full inspection">
                <div class="check_group">
                  <label for=""><span>[必填]</span>調理產品檢驗</label>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="T3_CookingProductStatus"
                      id="T3_CookingProductStatus1" v-bind:value="0"
                      v-model="EventItemDetailData.EventItemDetail.T3_CookingProductStatus"
                      data-field="T3_CookingProductStatus">
                    <label class="form-check-label" for="T3_CookingProductStatus1">
                      目前尚無調理產品
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="T3_CookingProductStatus"
                      id="T3_CookingProductStatus2" v-bind:value="1"
                      v-model="EventItemDetailData.EventItemDetail.T3_CookingProductStatus"
                      data-field="T3_CookingProductStatus">
                    <label class="form-check-label" for="T3_CookingProductStatus2">
                      現有調理產品皆尚未經過相關檢驗
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="T3_CookingProductStatus"
                      id="T3_CookingProductStatus3" v-bind:value="2"
                      v-model="EventItemDetailData.EventItemDetail.T3_CookingProductStatus"
                      data-field="T3_CookingProductStatus">
                    <label class="form-check-label" for="T3_CookingProductStatus3">
                      調理產品已進行最終產品檢驗
                    </label>
                    <div class="form-group" v-if="EventItemDetailData.EventItemDetail.T3_CookingProductStatus == 2">
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="T3_ComplianceWithFoodSafetyRegulations"
                          v-model="EventItemDetailData.EventItemDetail.T3_ComplianceWithFoodSafetyRegulations"
                          data-field="T3_ComplianceWithFoodSafetyRegulations">
                        <label class="form-check-label"
                          for="T3_ComplianceWithFoodSafetyRegulations">符合我國「食品安全衛生管理法」所訂食品相關衛生標準或相關規範</label>
                      </div>
                      <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="T3_ComplianceWithExportStandards"
                          v-model="EventItemDetailData.EventItemDetail.T3_ComplianceWithExportStandards"
                          data-field="T3_ComplianceWithExportStandards">
                        <label class="form-check-label"
                          for="T3_ComplianceWithExportStandards">符合輸出國之產品檢驗標準及包裝標示規定</label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h1 v-if="EventItemDetailData.EventItemDetail.T3_CookingProductStatus != 0">製作調理產品之食品工廠</h1>
            <div class="bg" v-if="EventItemDetailData.EventItemDetail.T3_CookingProductStatus != 0">
              <div class="form-group full inspection factory">
                <div class="check_group">
                  <label for=""><span>[必填]</span>製作調理產品之食品工廠</label>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="T3_FoodFactoryStatus" id="T3_FoodFactoryStatus1"
                      v-bind:value="0" v-model="EventItemDetailData.EventItemDetail.T3_FoodFactoryStatus"
                      data-field="T3_FoodFactoryStatus">
                    <label class="form-check-label" for="T3_FoodFactoryStatus1">
                      目前尚無自有或委外製作調理包之食品工廠
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="T3_FoodFactoryStatus" id="T3_FoodFactoryStatus2"
                      v-bind:value="1" v-model="EventItemDetailData.EventItemDetail.T3_FoodFactoryStatus"
                      data-field="T3_FoodFactoryStatus">
                    <label class="form-check-label" for="T3_FoodFactoryStatus2">
                      自有工廠
                    </label>
                    <div class="form-group" v-if="EventItemDetailData.EventItemDetail.T3_FoodFactoryStatus == 1">
                      <p>共</p>
                      <input type="number" class="form-control" aria-describedby="" placeholder="請填寫自有工廠數" min="0"
                        v-model.number="EventItemDetailData.EventItemDetail.T3_OwnFactoryQuantity">
                      <p>間</p>
                    </div>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="T3_FoodFactoryStatus" id="T3_FoodFactoryStatus3"
                      v-bind:value="2" v-model="EventItemDetailData.EventItemDetail.T3_FoodFactoryStatus"
                      data-field="T3_FoodFactoryStatus">
                    <label class="form-check-label" for="T3_FoodFactoryStatus3">
                      代工廠
                    </label>
                    <div class="form-group" v-if="EventItemDetailData.EventItemDetail.T3_FoodFactoryStatus == 2">
                      <p>合作廠商為</p>
                      <input type="text" class="form-control"
                        v-model="EventItemDetailData.EventItemDetail.T3_OEMFactoryCollaborators"
                        data-field="T3_OEMFactoryCollaborators"
                        :data-required="EventItemDetailData.EventItemDetail.T3_CookingProductStatus != 0 && EventItemDetailData.EventItemDetail.T3_FoodFactoryStatus == 2 ? '1' : '0'"
                        data-required-msg="請填代工廠合作廠商" aria-describedby="" placeholder="請填寫代工廠合作廠商">
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group full pass" v-if="EventItemDetailData.EventItemDetail.T3_FoodFactoryStatus != 0">
                <label for="">上述工廠已通過檢驗</label>
                <div class="form-group">
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_ISO22000Certification"
                      v-model="EventItemDetailData.EventItemDetail.T3_ISO22000Certification"
                      data-field="T3_ISO22000Certification">
                    <label class="form-check-label" for="T3_ISO22000Certification">ISO22000驗證</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_HACCPCertification"
                      v-model="EventItemDetailData.EventItemDetail.T3_HACCPCertification"
                      data-field="T3_HACCPCertification">
                    <label class="form-check-label" for="T3_HACCPCertification">HACCP驗證</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_HalalCertification"
                      v-model="EventItemDetailData.EventItemDetail.T3_HalalCertification"
                      data-field="T3_HalalCertification">
                    <label class="form-check-label" for="T3_HalalCertification">清真驗證</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_CASExcellentAgriculturalProductMark"
                      v-model="EventItemDetailData.EventItemDetail.T3_CASExcellentAgriculturalProductMark"
                      data-field="T3_CASExcellentAgriculturalProductMark">
                    <label class="form-check-label" for="T3_CASExcellentAgriculturalProductMark">CAS優良農產品標章</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_TQFTaiwanExcellentFoodCertification"
                      v-model="EventItemDetailData.EventItemDetail.T3_TQFTaiwanExcellentFoodCertification"
                      data-field="T3_TQFTaiwanExcellentFoodCertification">
                    <label class="form-check-label" for="T3_TQFTaiwanExcellentFoodCertification">TQF台灣優良食品驗證</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_SQFCertification"
                      v-model="EventItemDetailData.EventItemDetail.T3_SQFCertification"
                      data-field="T3_SQFCertification">
                    <label class="form-check-label" for="T3_SQFCertification">SQF驗證(Safe Quality Food
                      certification)</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_FSSF22000Certification"
                      v-model="EventItemDetailData.EventItemDetail.T3_FSSF22000Certification"
                      data-field="T3_FSSF22000Certification">
                    <label class="form-check-label" for="T3_FSSF22000Certification">FSSF 22000驗證(Food Safety System
                      certification)</label>
                  </div>
                  <div class="form-check">
                    <input type="checkbox" class="form-check-input" id="T3_OtherCertifications"
                      v-model="EventItemDetailData.EventItemDetail.T3_OtherCertifications"
                      data-field="T3_OtherCertifications">
                    <label class="form-check-label" for="T3_OtherCertifications">其他</label>
                    <input type="text" class="form-control"
                      v-if="EventItemDetailData.EventItemDetail.T3_OtherCertifications"
                      v-model="EventItemDetailData.EventItemDetail.T3_OtherCertificationsContent"
                      data-field="T3_OtherCertificationsContent"
                      :data-required="EventItemDetailData.EventItemDetail.T3_CookingProductStatus != 0 && EventItemDetailData.EventItemDetail.T3_OtherCertifications ? '1' : '0'"
                      data-required-msg="請填寫其他檢驗內容" aria-describedby="" placeholder="請填寫其他檢驗內容">
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div class="btn_box">
              <router-link :to="{ name: 'EventItem', params: { EId: EventItemDetailData.Event.EId } }"
                tag="button">返回列表</router-link>
              <!-- <button @click="save(true)"
                v-if="EventItemDetailData.Review.ReviewStatus == 0 || EventItemDetailData.Review.ReviewStatus == 3">暫存資料</button> -->
              <button @click="save(false)"
                v-if="EventItemDetailData.Review.ReviewStatus == 0 || EventItemDetailData.Review.ReviewStatus == 3">儲存資料</button>
            </div>
          </div>
        </div>
      </section>
    </div><!-- wrapper -->
    <Footer />
  </div>
</template>
<script>
import Head from "@/components/Head.vue";
import Footer from "@/components/Footer.vue";

import Vue from "vue";

import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);


import AES from "@/utils/aes.js";
import Validate from "@/utils/validate.js";

export default {
  name: "EventItemDetail_3",
  components: {
    Head,
    Footer,
  },
  data() {
    return {
      EIDId: -1,
      EventItemDetailData: {},
      SideDishes: [],
    };
  },
  beforeCreate: function () {
    if (!$cookies.isKey("is_login_token")) {
      Swal.fire({
        title: "請先登入帳號",
        icon: "info",
        allowOutsideClick: false,
        heightAuto: false,
        willClose: () => {
          this.$router.push({
            name: "LoginForUser",
          });
        },
      });
      return;
    }
  },
  created: function () {
    if (this.$route.params.EIDId) {
      this.EIDId = this.$route.params.EIDId;
    }
    Vue.axios
      .get(
        this.$store.state.src + this.$store.state.subDirectory + "/Html/EventItemDetail",
        {
          params: { EId: this.$route.params.EId, EIId: this.$route.params.EIId, EIDId: this.EIDId, token: $cookies.get("is_login_token") },
        }
      )
      .then((response) => {
        this.EventItemDetailData = response.data;
        this.SideDishes = this.EventItemDetailData.SideDishes;
        if (!this.EventItemDetailData.UserInfo ||
          this.EventItemDetailData.UserInfo.UIId == -1) {
          Swal.fire({
            title: "請先填寫基本資料",
            icon: "info",
            allowOutsideClick: false,
            heightAuto: false,
            willClose: () => {
              this.$router.push({
                name: "BaseInfo",
                params: { EId: this.$route.params.EId },
              });
            },
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  mounted: function () {
  },
  updated: function () {
    if (this.EventItemDetailData.Review.ReviewStatus != 0 && this.EventItemDetailData.Review.ReviewStatus != 3) {
      $("#stet_1 input").attr("disabled", "disabled").off('click');
      $("#stet_1 textarea").attr("disabled", "disabled").off('click');
    }
    this.setInputMaxlengths();
  },
  methods: {
    checkFiles(event) {
      let that = this;
      var id = event.target.id;
      var e = event.target;
      if (e.files.length != 0) {
        // 顯示請稍候
        Swal.fire({
          title: "請稍候...",
          allowOutsideClick: false,
          showConfirmButton: false,
          heightAuto: false,
          willOpen: function () {
            Swal.showLoading();
          },
        });
        var file = e.files[0];
        // 不進行壓縮的情況要檢查大小
        if (file.size > 104857600) {
          Swal.fire({
            title: "錯誤",
            text: "檔案大小超過100MB",
            icon: "error",
            allowOutsideClick: false,
            confirmButtonText: "確定",
            heightAuto: false,
          });
        } else {
          var reader = new FileReader();
          reader.onloadend = function () {
            if (id == "T3_ItemPhotos") {
              that.EventItemDetailData.EventItemDetail.T3_ItemPhotos = reader.result;
            } else if (id == "T3_ItemPhotos2") {
              that.EventItemDetailData.EventItemDetail.T3_ItemPhotos2 = reader.result;
            } else if (id == "T3_ItemPhotos3") {
              that.EventItemDetailData.EventItemDetail.T3_ItemPhotos3 = reader.result;
            } else if (id == "T3_ItemPhotos4") {
              that.EventItemDetailData.EventItemDetail.T3_ItemPhotos4 = reader.result;
            } else if (id == "T3_ItemPhotos5") {
              that.EventItemDetailData.EventItemDetail.T3_ItemPhotos5 = reader.result;
            }
            $("#" + id + "_data").val(reader.result);
            $("#" + id + "_name").val(file.name);
            //$("#" + id).val('');
            Swal.close();
          };
          reader.onerror = function (error) {
            $("#" + id).val("");
            Swal.fire({
              title: "錯誤",
              html:
                "處理檔案過程發生錯誤:<br />" +
                error +
                "<br />若持續發生此問題請聯繫客服人員, 造成不便敬請見諒",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          };
          reader.readAsDataURL(file);
        }
      }
    },
    addSideDishe() {
      this.SideDishes.push({
        SideDisheContent: '',
        IngredientOrigin: '',
        LocalIngredientsRatio: 0,
        DomesticProductRecord: false,
        UseExtraIngredients: false,
      });
    },
    removeSideDishe() {
      if (this.SideDishes.length > 1) {
        this.SideDishes.splice(this.SideDishes.length - 1);
      }
    },
    save(isTemp) {
      if (isTemp) {
        this.EventItemDetailData.EventItemDetail.IsTemp = true;
      } else {
        this.EventItemDetailData.EventItemDetail.IsTemp = false;
        var hasError = false;
        $("[data-required='1']").each(function () {
          var input = $(this);
          if (!input.val() || input.val() == '-1') {
            input.focus();
            Swal.fire({
              title: "錯誤",
              text: input.data("required-msg"),
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
            hasError = true;
            return false;
          } else if (input.attr("type") == "email" &&
            !Validate.reg_email(input.val())) {
            Swal.fire({
              title: "錯誤",
              text: "Email格式錯誤",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
            hasError = true;
            return false;
          } else if (input.attr("type") == "number" &&
            input.val() < 0) {
            Swal.fire({
              title: "錯誤",
              text: "數字不可小於0",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
            hasError = true;
            return false;
          }
        });
        if (hasError) {
          return;
        }
        var SideDisheError = false;
        $.each(this.SideDishes, function (index, SideDishe) {
          if (SideDishe.SideDisheContent == "" ||
            SideDishe.IngredientOrigin == "") {
            SideDisheError = true;
            return;
          }
          if (SideDisheError) {
            Swal.fire({
              title: "錯誤",
              text: "請確實輸入配菜資料",
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
            return;
          }
        });
      }
      Swal.fire({
        title: "請稍候...",
        allowOutsideClick: false,
        showConfirmButton: false,
        heightAuto: false,
        willOpen: function () {
          Swal.showLoading();
        },
      });
      // 儲存檔案名稱
      var AttachmentNames = "{";
      $("[data-namgtag='1']").each(function () {
        if (AttachmentNames.length > 1) { AttachmentNames += ", "; }
        var input = $(this);
        AttachmentNames += '"' + input.attr("id").replace("_name", "") + '": "' + input.val() + '"';
      });
      AttachmentNames += "}";
      let that = this;
      $.ajax({
        url:
          that.$store.state.src +
          that.$store.state.subDirectory +
          "/Html/EventItemDetail",
        type: "post",
        data: {
          EventItemDetailJson: JSON.stringify(that.EventItemDetailData.EventItemDetail),
          AttachmentNames: AttachmentNames,
          SideDishes: JSON.stringify(that.SideDishes),
          token: $cookies.get("is_login_token")
        },
        dataType: "json",
        error: function () { },
        success: function (res) {
          if (res.ok) {
            Swal.fire({
              title: isTemp ? "暫存成功" : "儲存成功",
              text: "即將返回列表",
              icon: "success",
              allowOutsideClick: false,
              showConfirmButton: false,
              heightAuto: false,
              timer: 1500,
              willClose: () => {
                that.$router.push({
                  name: "EventItem",
                  params: { EId: that.EventItemDetailData.Event.EId }
                });
              },
            });
          } else if (res.error) {
            Swal.fire({
              title: "錯誤",
              text: res.error,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: "確定",
              heightAuto: false,
            });
          }
        }
      });
    },
    goto(pageName) {
      this.$router.push({
        name: pageName,
        params: { EId: this.$route.params.EId },
      });
    },
    sendReview() {
      let that = this;
      Swal.fire({
        heightAuto: false,
        title: "請再次確認",
        text: "送出審核後將無法再進行修改，是否確認送出?",
        icon: "info",
        allowOutsideClick: false,
        confirmButtonText: "是",
        showCancelButton: true,
        cancelButtonText: "否",
      })
        .then((result) => {
          if (result.isConfirmed) {
            Swal.fire({
              title: "請稍候...",
              allowOutsideClick: false,
              showConfirmButton: false,
              heightAuto: false,
              willOpen: function () {
                Swal.showLoading();
              },
            });
            $.ajax({
              url:
                that.$store.state.src +
                that.$store.state.subDirectory +
                "/Html/SendReview",
              type: "post",
              data: {
                EId: this.$route.params.EId,
                token: $cookies.get("is_login_token")
              },
              dataType: "json",
              error: function () { },
              success: function (res) {
                if (res.ok) {
                  Swal.fire({
                    title: "送出成功",
                    icon: "success",
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    heightAuto: false,
                    timer: 1500,
                    willClose: () => {
                      location.reload();
                    },
                  });
                } else if (res.error) {
                  Swal.fire({
                    title: "錯誤",
                    text: res.error,
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: "確定",
                    heightAuto: false,
                  });
                }
              }
            });
          }
        });
    },
    setInputMaxlengths() {
      const self = this;
      $('input[type="text"][data-field], textarea[data-field]').each(function () {
        const $input = $(this);
        const field = $input.data('field');
        const lengthInfo = self.EventItemDetailData.ColumnLengthInfos[field];
        if (lengthInfo) {
          $input.attr('maxlength', lengthInfo);
        }
      });
      $('input[type="number"]').each(function () {
        const $input = $(this);
        $input.attr({
          type: 'text',
          inputmode: 'numeric',
          pattern: '[0-9]*',
          oninput: "this.value = this.value.replace(/[^0-9]/g, '')",
          onpaste: "event.preventDefault()",
          'data-required': '1',
        });
        const placeholder = $input.attr('placeholder') || '';
        $input.attr('data-required-msg', placeholder);
        $input.removeAttr('min');
        // 4. 設定預設值為 0（若為空）
        if ($input.val().trim() === '') {
          $input.val('0');
        }
        // 5. 當失焦時，若為空自動補 0
        $input.on('blur', function () {
          if ($(this).val().trim() === '') {
            $(this).val('0');
          }
        });
      });
    }
  },
};
</script>
